import React from 'react'
import './footer.css';
import twitter from './images/twitter2.png';
import youtube from './images/youtub2.png';
import instagram from './images/insta (2).png'
import linkdin from './images/linkdin2.png';
import location from './images/location.png';
import mobile from './images/mobile.png';
import email from './images/Mail1.png';

const footer = () => {
  return (
    <div className='footer'>
      <div className='footer-div'>

<div className='footer-top'>
<div className='footer-top-left'>
<h1>Cyber Security Learning (CSL)</h1>
<span>At CSL (Cyber Security Learning), we believe anyone can learn to defend the digital world — they just need the right training. Located in Gurgaon and proudly serving students across Delhi NCR, we offer hands-on cybersecurity courses built for real careers. From ethical hacking to advanced threat defense, we are here to guide you every step of the way.</span>
<div className='icons'>
<a href='https://x.com/home?lang=en-in'><img src={twitter} alt=''/></a>
<a href='https://youtube.com/@csl_cybersecuritylearning?si=tdd0SR-4MLTbh69r'><img src={youtube} alt=''/></a>
<a href='https://www.instagram.com/csl_cybersecuritylearning/'><img src={instagram} alt=''/></a>
<a href='https://www.linkedin.com/in/cyber-security-learning-csl-896a8b3ba/?isSelfProfile=true'><img src={linkdin} alt=''/></a>
</div>
</div>
<div className='footer-top-right'>
<input type='text' placeholder='Enter Email Address'/>
<button>Subscribe</button>
</div>
<div>

</div>
</div>

<div className='footer-bottom'>
<div className='foot-items'>
<h3>AI-ENABLED TRAINING</h3>
<ul>
  <li><a href='#'>Cisco Certificate</a></li>
   <li><a href='#'>CCNA</a></li>
    <li><a href='#'>Ethical Hacking</a></li>
      <li><a href='#'>Linux</a></li>
        <li><a href='#'></a></li>
          <li><a href='#'></a></li>
            <li><a href='#'></a></li>
              <li><a href='#'></a></li>
                <li><a href='#'></a></li>
</ul>
</div>
{/* <div className='foot-items'>
  <h3>Digital Courses</h3>
<ul>
  <li><a href='#'>Content-Marketing</a></li>
    <li><a href='#'>Website Development</a></li>
      <li><a href='#'>Search-Engine-Optimization</a></li>
        <li><a href='#'>Graphic-Design</a></li>
          <li><a href='#'>Data Analytics & GTM</a></li>
            <li><a href='#'>Video-Editing</a></li>
              <li><a href='#'>Social-Media-Marketing</a></li>
</ul>
</div> */}

<div className='foot-items'>
  <h3>Quick Links</h3>
<ul>
  <li><a href='#'>Privacy Policy</a></li>
    <li><a href='#'>Terms & Conditions</a></li>
      <li><a href='#'>Disclaimer</a></li>
        <li><a href='#'>About US</a></li>
          <li><a href='#'>Contact Us</a></li>
</ul>
</div>

<div className='foot-items'>
  <h3>Contact Info</h3>
  <div className='contact-detail'>
<ul>
  <li>
    <a href='#'><h4>Address:</h4>
    <div className='foot-items-info'>
<img src={location} alt=''/>
<span> Gurugram</span>
    </div>
  </a>
  </li>
    <li><a href='#'>
      <h4>Mobile:</h4>
      <div className='foot-items-info'>
        <img src={mobile} alt=''/>
<span>+91 81780 67868</span>
      </div>
    </a>
    </li>
      <li><a href='#'>
        <h4>Email:</h4>
         <div className='foot-items-info'>
        <img src={email} alt=''/>
<span>csl260399@gmail.com</span>
      </div>
        </a>
        </li>
</ul>
</div>
</div>
</div>
<div className='copyright'>
  <div className='c-right'>
<span>Copyright © 2026 |Created By - CSL Team</span>
</div>
</div>
      </div>
    </div>
  )
}

export default footer
